import { RootState } from 'store';

export const selectors = {
  selectCustomerId: (state: RootState) => state.stripe.customerId,
  selectIsExistingCustomer: (state: RootState) => state.stripe.isExistingCustomer,
  selectStripeCustomerId: (state: RootState) => state.stripe.stripeCustomerId,
  selectClientSecret: (state: RootState) => state.stripe.clientSecret,
};
